import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionSummary, Typography } from '@mui/material';
import React from 'react';
import {
  ISIVChecklistAdverseEventReporting,
  ISIVChecklistMonitoring,
  ISIVChecklistRequirementsforEcrfcompletion,
  ISIVChecklistSourceDocumentation
} from 'src/types/SIVChecklist';
import AdverseEventReporting from './AdverseEventReporting';
import Monitoring from './Monitoring';
import RequirementsforEcrfcompletion from './RequirementsforEcrfcompletion';
import './SivChecklist.scss';
import SourceDocumentation from './SourceDocumentation';
import {
  ISIVChecklistMandatory,
  ISIVChecklistModifiedKeys,
  ISIVChecklistModifiedKeysOfKeys,
  ISIVChecklistStep2Accordions,
  MandatoryData
} from './useSivChecklist';

export interface ISQChecklistPageStep2 {
  getSivChecklistData: (key: ISIVChecklistModifiedKeysOfKeys, add: boolean) => void;
  saveDisable: boolean;
  setSaveDisable: (saveDisable: boolean) => void;
  expandedState: ISIVChecklistStep2Accordions;
  toggle: (key: keyof ISIVChecklistStep2Accordions, expanded: boolean) => void;
  adverseEventReportingData: ISIVChecklistAdverseEventReporting;
  updateAdverseEventReporting: (data: ISIVChecklistAdverseEventReporting) => void;
  updateSourceDocumentation: (data: ISIVChecklistSourceDocumentation) => void;
  sourceDocumentationData: ISIVChecklistSourceDocumentation;
  updateMonitoring: (data: ISIVChecklistMonitoring) => void;
  monitoringData: ISIVChecklistMonitoring;
  requirementsforEcrfCompletionData: ISIVChecklistRequirementsforEcrfcompletion;
  updateRequirementsforEcrfCompletion: (data: ISIVChecklistRequirementsforEcrfcompletion) => void;
  isUpdate: boolean;
  setIsChange: (step: ISIVChecklistModifiedKeys, key: ISIVChecklistModifiedKeysOfKeys, val: boolean) => void;
  Step2: ISIVChecklistStep2Accordions;
  updateSIVChecklistMandatoryData: (key: keyof ISIVChecklistMandatory, value: MandatoryData) => void;
  mandatory: ISIVChecklistMandatory;
  validateadverseEventReporting: any;
  validaterequirementsforEcrfcompletion: any;
  validatesourceDocumentation: any;
  validatemonitoring: any;
  checkedInStartDate: any;
  isPublished: boolean;
  SignatureBreaking: () => void;
}

const SQChecklistPage: React.FunctionComponent<ISQChecklistPageStep2> = ({
  getSivChecklistData,
  saveDisable,
  setSaveDisable,
  expandedState,
  toggle,
  adverseEventReportingData,
  updateAdverseEventReporting,
  sourceDocumentationData,
  updateSourceDocumentation,
  requirementsforEcrfCompletionData,
  updateRequirementsforEcrfCompletion,
  monitoringData,
  updateMonitoring,
  isUpdate,
  setIsChange,
  Step2,
  updateSIVChecklistMandatoryData,
  mandatory,
  validateadverseEventReporting,
  validaterequirementsforEcrfcompletion,
  validatesourceDocumentation,
  validatemonitoring,
  checkedInStartDate,
  isPublished,
  SignatureBreaking
}) => {
  return (
    <div className="pi-accordion siv-accordion">
      <Accordion
        expanded={expandedState.adverseEventReporting}
        onChange={(_, expanded) => {
          toggle('adverseEventReporting', expanded);
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
          <Typography>Adverse Event Reporting </Typography>
        </AccordionSummary>
        <AdverseEventReporting
          adverseEventReportingData={adverseEventReportingData}
          getSivChecklistData={getSivChecklistData}
          saveDisable={saveDisable}
          isChange={Step2.adverseEventReporting}
          updateAdverseEventReporting={updateAdverseEventReporting}
          isUpdate={isUpdate}
          setIsChange={setIsChange}
          updateSIVChecklistMandatoryData={updateSIVChecklistMandatoryData}
          mandatory={mandatory.adverseEventReporting}
          validateadverseEventReporting={validateadverseEventReporting}
          checkedInStartDate={checkedInStartDate}
          isPublished={isPublished}
          SignatureBreaking={SignatureBreaking}
        />
      </Accordion>

      <Accordion
        expanded={expandedState.requirementsforEcrfcompletion}
        onChange={(_, expanded) => {
          toggle('requirementsforEcrfcompletion', expanded);
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2bh-content" id="panel2bh-header">
          <Typography sx={{ width: '33%', flexShrink: 0 }}>
            Requirements for eCRF completion{' '}
            {/* <Button variant="text" className="btn-static">
              <OpenInNewIcon />
            </Button> */}
          </Typography>
        </AccordionSummary>
        <RequirementsforEcrfcompletion
          getSivChecklistData={getSivChecklistData}
          isChange={Step2.requirementsforEcrfcompletion}
          saveDisable={saveDisable}
          requirementsforEcrfCompletionData={requirementsforEcrfCompletionData}
          updateRequirementsforEcrfCompletion={updateRequirementsforEcrfCompletion}
          isUpdate={isUpdate}
          setIsChange={setIsChange}
          updateSIVChecklistMandatoryData={updateSIVChecklistMandatoryData}
          mandatory={mandatory.requirementsforEcrfcompletion}
          validaterequirementsforEcrfcompletion={validaterequirementsforEcrfcompletion}
          checkedInStartDate={checkedInStartDate}
          isPublished={isPublished}
          SignatureBreaking={SignatureBreaking}
        />
      </Accordion>

      <Accordion
        expanded={expandedState.sourceDocumentation}
        onChange={(_, expanded) => {
          toggle('sourceDocumentation', expanded);
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel3bh-content" id="panel3bh-header">
          <Typography sx={{ width: '33%', flexShrink: 0 }}>Source Documentation </Typography>
        </AccordionSummary>
        <SourceDocumentation
          getSivChecklistData={getSivChecklistData}
          saveDisable={saveDisable}
          sourceDocumentationData={sourceDocumentationData}
          updateSourceDocumentation={updateSourceDocumentation}
          isUpdate={isUpdate}
          isChange={Step2.sourceDocumentation}
          setIsChange={setIsChange}
          updateSIVChecklistMandatoryData={updateSIVChecklistMandatoryData}
          mandatory={mandatory.sourceDocumentation}
          validatesourceDocumentation={validatesourceDocumentation}
          checkedInStartDate={checkedInStartDate}
          isPublished={isPublished}
          SignatureBreaking={SignatureBreaking}
        />
      </Accordion>

      <Accordion
        expanded={expandedState.monitoring}
        onChange={(_, expanded) => {
          toggle('monitoring', expanded);
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel4bh-content" id="panel4bh-header">
          <Typography sx={{ width: '33%', flexShrink: 0 }}>Monitoring </Typography>
        </AccordionSummary>
        <Monitoring
          getSivChecklistData={getSivChecklistData}
          saveDisable={saveDisable}
          monitoringData={monitoringData}
          updateMonitoring={updateMonitoring}
          isUpdate={isUpdate}
          isChange={Step2.monitoring}
          setIsChange={setIsChange}
          updateSIVChecklistMandatoryData={updateSIVChecklistMandatoryData}
          mandatory={mandatory.monitoring}
          validatemonitoring={validatemonitoring}
          checkedInStartDate={checkedInStartDate}
          isPublished={isPublished}
          SignatureBreaking={SignatureBreaking}
        />
      </Accordion>
    </div>
  );
};

export default SQChecklistPage;
